module.exports = __webpack_public_path__ + "img/NG.9ef191e0.svg";